import {api} from '../api';

function formSubmit(form) {
    const formData = new FormData(form);

    api.post('service/', {body: formData})
        .json()
        .then((response) => {
            showResult(form, response.message);
        });
}

function showResult(form, message) {
    const result = form.querySelector('.result');
    result.textContent = message;
    result.style.display = 'block';
}

document.addEventListener('DOMContentLoaded', () => {
    const dialog = document.getElementById('serviceForm');
    const form = dialog.querySelector('form');
    const select = form.querySelector('.form__select');
    const button = form.querySelector('.bx_filter_parameters_box_title');

    button.addEventListener('click', () => {
        select.classList.toggle('active');
    });

    const submitButton = form.querySelector('button[type="submit"]');
    submitButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        formSubmit(form);
    });
});
